module.exports = __webpack_public_path__ + "@/assets/img/clipboard-check.73c96b3c.svg";